<!--
 * @Description: 登录
 * @Author: huangshiwen
 * @Date: 2022-05-30 13:40:58
 * @LastEditTime: 2025-12-09 14:15:04
-->
<template>
 <div div style="background:#fff">
    <div class="yygh-title">预约挂号</div>
   <Common>
      <template slot="cd">
        <CdhospitalBookTab currentIndex="2"/>
        <CdhospitalTelephoneBook/>
      </template>
      <template slot="sz">
        <SzhospitalBookTab currentIndex="2"/>
        <SzhospitalTelephoneBook />
      </template>
      <template slot="hf">
        <HfhospitalBookTab currentIndex="2"/>
        <HfhospitalTelephoneBook />
      </template>
    </Common>
</div>
   
</template>

<script>
import CdhospitalTelephoneBook from "@/components/hospitalTelephoneBook/cdhospitalTelephoneBook"
import SzhospitalTelephoneBook from "@/components/hospitalTelephoneBook/szhospitalTelephoneBook"
import HfhospitalTelephoneBook from "@/components/hospitalTelephoneBook/hfhospitalTelephoneBook"
import CdhospitalBookTab from "@/components/hospitalBookTab/cdhospitalBookTab"
import SzhospitalBookTab from "@/components/hospitalBookTab/szhospitalBookTab"
import HfhospitalBookTab from "@/components/hospitalBookTab/hfhospitalBookTab"
export default{
  components:{
    CdhospitalTelephoneBook,
    SzhospitalTelephoneBook,
    HfhospitalTelephoneBook,
    SzhospitalBookTab,
    CdhospitalBookTab,
    HfhospitalBookTab
  },
  
  data(){
    return {

    }
  },
  created(){

  }
}
</script>
<style lang="less" scoped>
.yygh-title{
  text-align: center;
  font-size: 30px;
  line-height: 30px;
  padding-top:50px;
  background: #fff;
}
.m-screen-mobile .yygh-title {
  padding-top: 0.8rem;
  font-size: 0.45rem!important;
  text-align: center;
  line-height: 0.46rem!important;
}
</style>